function pointer () {
  const pointer = document.querySelector('.pointer')
  const pointerWorks = document.querySelectorAll('.pointer-works')
  // const pointerVideo = document.querySelectorAll('.pointer-video')
  // const pointerMouse = document.querySelectorAll('.pointer-mouse')

  // Optimización: Usar requestAnimationFrame para el mousemove
  let rafId
  document.addEventListener('mousemove', (e) => {
    if (rafId) cancelAnimationFrame(rafId)

    rafId = requestAnimationFrame(() => {
      pointer.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`
    })
  })

  // Verificar si el elemento o alguno de sus padres tiene la clase pointer-avoid
  function hasPointerAvoidClass(element) {
    if (!element || element === document.body) return false
    if (element.classList && element.classList.contains('pointer-avoid')) return true
    return hasPointerAvoidClass(element.parentElement)
  }

  function handleHover (elements, className) {
    elements.forEach(element => {
      // Usar event delegation para manejar todos los elementos internos
      element.addEventListener('mouseover', (e) => {
        // Si el elemento sobre el que está el cursor tiene la clase pointer-avoid o está dentro de uno, no aplicar el efecto
        if (hasPointerAvoidClass(e.target)) {
          pointer.classList.remove(className)
          return
        }
        pointer.classList.add(className)
      })

      element.addEventListener('mouseout', (e) => {
        // Si el elemento al que va el cursor está dentro del mismo contenedor y no tiene la clase pointer-avoid
        if (element.contains(e.relatedTarget) && !hasPointerAvoidClass(e.relatedTarget)) {
          return
        }
        pointer.classList.remove(className)
      })
    })
  }

  if (pointerWorks?.length) {
    handleHover(pointerWorks, 'pointer-works')
  }

  // if (pointerVideo?.length) {
  //   handleHover(pointerVideo, 'pointer-video')
  // }
}

export default pointer
